import { render, staticRenderFns } from "./ServiceFormEdit.vue?vue&type=template&id=681a2480&scoped=true&"
import script from "./ServiceFormEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormEdit.vue?vue&type=style&index=0&id=681a2480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a2480",
  null
  
)

export default component.exports